var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags-icon"},[_c('img',{staticClass:"tags-icon__image",attrs:{"src":require('@/assets/tags.svg'),"alt":"Tags Icon"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }